import { Box } from '@mui/material'
import ProgramPageHero from '../components/programs/ProgramPageHero'
import ProgramWhySection from '../components/programs/ProgramWhySection'
import ChangeMakerMissionSection from '../components/change-maker/ChangeMakerMissionSection'
import ChangeMakerHowToJoinSection from '../components/change-maker/ChangeMakerHowToJoinSection'
import { sharedStarIcon } from '../assets/index'
import {
  changeMakerHero,
  joinMission,
  whyVolunteer,
  whoCanVolunteer,
} from '../data/changeMakerContent'
import {
  programSectionWrapperSx,
  programInnerSx,
  programSectionGap,
} from '../components/programs/programLayout'
import { mobileSectionPy } from '../theme/mobileLayout'

const changeMakerBodyFontSize = { xs: 16, sm: 22, md: 26, lg: 26 }

export default function ChangeMakerPage() {
  return (
    <Box sx={{ bgcolor: '#fffefa' }}>
      <Box
        sx={{
          ...programSectionWrapperSx,
          pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
          pb: { xs: 6, md: 8 },
        }}
      >
        <Box sx={{ maxWidth: 870, mx: 'auto', width: '100%' }}>
          <ProgramPageHero
            title={changeMakerHero.title}
            subtitle={changeMakerHero.subtitle}
            cta={changeMakerHero.cta}
            ctaLink={changeMakerHero.ctaLink}
            subtitleSx={{ fontSize: changeMakerBodyFontSize }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          ...programSectionWrapperSx,
          pb: { xs: 8, md: 12, lg: '150px' },
        }}
      >
        <Box
          sx={{
            ...programInnerSx,
            display: 'flex',
            flexDirection: 'column',
            gap: programSectionGap,
          }}
        >
          <ChangeMakerMissionSection title={joinMission.title} text={joinMission.text} />

          <ProgramWhySection
            title={whyVolunteer.title}
            items={whyVolunteer.items}
            starSrc={sharedStarIcon}
            titleMaxWidth={whyVolunteer.titleMaxWidth}
          />

          <ProgramWhySection
            title={whoCanVolunteer.title}
            items={whoCanVolunteer.items}
            starSrc={sharedStarIcon}
            titleMaxWidth={whoCanVolunteer.titleMaxWidth}
          />

          <ChangeMakerHowToJoinSection />
        </Box>
      </Box>
    </Box>
  )
}
